<template>
<v-layout row wrap justify-center align-center no-gutters>
  <v-flex xs12 sm9 class="ma-0 py-8 px-3">
      <div cols="12" class="text-left txt-primary mt-1 mb-4">
        <h1> {{itemsec.titulo}} </h1>
      </div>
      <div class="card-conv">
        <div v-for="(tran, idx) in aAlianzas" :key="'tran-'+idx" @click="actionBtn(tran.url_link)"
        class="text-left mx-auto d-flex justify-start align-center item-convenio">
          <img :src="tran.logo" width="100px" :alt="tran.desc_link">
          <!-- <img :src="require('../assets/img/convenios/'+tran.logo+'.png')" alt="" > -->
          <p>{{tran.desc_link}}</p>
        </div>
      </div>
  </v-flex>

</v-layout>
</template>
<script>
import axios from 'axios'
export default {
  name: 'secAlianzas',
  data () {
    return {
      itemsec: {
        titulo: 'Agremiaciones y Asociaciones'
      },
      aAlianzas: []
    }
  },
  methods: {
    actionBtn (val) {
      window.open(val)
    }
  },
  async created () {
    await axios
      .get('' + this.$store.state.rutaApi + 'links_agremiaciones')
      .then(response => (this.aAlianzas = response.data))
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/globals.scss';

.card-item{
  padding: 10px;
  text-align: center;
  color: #2B5AC4;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.6)!important;

  h3{
    font-size: 1em;
  }
}
.card-conv{
  background: #FFFFFF;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
  height: 300px;
  overflow-y: scroll;
  .item-convenio{
    margin: 5px 0px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    border-radius: 10px;
    &:hover{
      background: rgba(0, 0, 0, 0.05);
    }
    img{
      width: 50px;
    }
    p{
      margin: 0px;
      padding: 0px;
      margin-left: 10px;
      line-height: 1em;
    }

  }
}
</style>
